import { render } from "./AdminVoiceOfGodUserList.vue?vue&type=template&id=32fc6d48&scoped=true"
import script from "./AdminVoiceOfGodUserList.vue?vue&type=script&lang=js"
export * from "./AdminVoiceOfGodUserList.vue?vue&type=script&lang=js"

import "./AdminVoiceOfGodUserList.vue?vue&type=style&index=0&id=32fc6d48&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fc6d48"]])

export default __exports__